import {
  ContentDataBlockImage,
  ContentDataBlockText,
  parseContent,
} from '@amf/shared/components/content/Content';

export function getContentImageUrl(data: string): string | null {
  const content = parseContent(data);
  if (!content) {
    return null;
  }

  const images = content.blocks.filter(b => b.type === 'image') as ContentDataBlockImage[];

  if (images.length === 0) {
    return null;
  }

  return images[0].data.file.url;
}

export function getContentDescription(data: string): string | null {
  const content = parseContent(data);
  if (!content) {
    return null;
  }

  const texts = content.blocks.filter(b => b.type === 'paragraph') as ContentDataBlockText[];

  if (texts.length === 0) {
    return null;
  }

  return texts[0].data.text.replace(/(<([^>]+)>)/gi, '');
}
